import React from 'react'

const PageWrapper = (props) => {
    return (
        <div style={styles.wrapper} id={props.id || null}>
            {props.children}
        </div>
    )
}

const styles = {
    wrapper: {
        padding: '20px',
    }
}

export default PageWrapper